import React, { useState } from 'react'
import { ReactComponent as IncomingCall } from 'components/CRM/UI/icons/incoming-call.svg'
import { ReactComponent as OutgoingCall } from 'components/CRM/UI/icons/outgoing-call.svg'
import CallItem from './CallItem/CallItem'
import st from './CallList.module.scss'

const CallList = ({ data, setCallFilter, callFilter, translate }) => {
  const [activeCallId, setActiveCallId] = useState(null)

  const toggleTranscription = (callId) => {
    setActiveCallId(activeCallId === callId ? null : callId)
  }

  return (
    <div className={st.tableContainer}>
      <div className={st.flexTable}>
        <div className={st.lastCallHeaderBlock}>
          <div className={st.header}>{translate?.last_calls}</div>
          <div className={st.lastCallFilters}>
            <div
              className={callFilter === 'all' ? st.active : ''}
              onClick={() => setCallFilter('all')}
            >
              {translate?.all}
            </div>
            <div
              className={callFilter === 'incoming' ? st.active : ''}
              onClick={() => setCallFilter('incoming')}
            >
              {translate?.incoming} <IncomingCall />
            </div>
            <div
              className={callFilter === 'outgoing' ? st.active : ''}
              onClick={() => setCallFilter('outgoing')}
            >
              {translate?.outgoing} <OutgoingCall />
            </div>
            <div
              className={callFilter === 'callback' ? st.active : ''}
              onClick={() => setCallFilter('callback')}
            >
              {translate?.call_back} <OutgoingCall />
            </div>
          </div>
        </div>
        <div className={st.flexRow}>
          <div className={`${st.flexColumn} ${st.date}`}>
            {translate?.call_date}
          </div>
          <div className={`${st.flexColumn} ${st.eventText}`}>
            {translate?.event}
          </div>
          <div className={`${st.flexColumn} ${st.result}`}>
            {translate?.result}
          </div>
          <div className={`${st.flexColumn} ${st.duration}`}>
            {translate?.duration_label}
          </div>
          <div className={`${st.flexColumn} ${st.record}`}>
            {translate?.recording}
          </div>
        </div>

        {data?.map((call, index) => (
          <CallItem
            key={call.id}
            call={call}
            index={index}
            activeCallId={activeCallId}
            toggleTranscription={toggleTranscription}
            translate={translate}
          />
        ))}
      </div>
    </div>
  )
}

export default CallList
